import React, { useEffect, useState } from "react";
import $ from "jquery";
import Slider from "react-slick"; // Import Slider component
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import'../network/Css/Hexagonalgallery.css'

const HexagonalGallery = (props) => {
  const [myConnectionMore, setMyConnectionMore] = useState(false);
  // console.log('props.images[0].images');

  // Arrow button hide for mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

// Function to handle clicking on a profile
  function handleProfileClick(e, profileUrl) {
    e.preventDefault();
    window.location.href = "/user/contact/" + profileUrl;
  }


  const calculateNumberOfRows = (totalItems, itemsPerRow) => {
    return Math.ceil(totalItems / itemsPerRow);
  };
  
 // Function to create the hexagonal gallery
 const createHoneycomb = () => {
  if ($(".hex-gallery-item").length > 0) {
    var galleryWrapper = $(".hex-gallery-wrapper");
    galleryWrapper.html("");
    const itemsInRow = 8;
    var modValue = itemsInRow;
    let rows = calculateNumberOfRows(props.images.length, modValue);
    // console.log("Number of rows:", rows);
    var hexWidth =
      galleryWrapper.width() / parseInt(modValue + (modValue - 1) / 1.7);

    if ($(window).width() < 991) {
      modValue = 5;
      hexWidth =
        galleryWrapper.width() / parseInt(modValue + (modValue - 1) / 2);
    }
    if ($(window).width() < 767) {
      modValue = 3;
      hexWidth =
        galleryWrapper.width() / parseInt(modValue + (modValue - 1) / 2);
    }
    var smallWidth = hexWidth - (hexWidth / 2) * 0.5;
    let styleString = ""; // Updated variable declaration
    let verticalHeight = (hexWidth / 2) * 0.86602540378;
    let hexagonGalSvg = "";
    let leftPos = 0;
    let topPos = 0;
    var itemCounter = 0;
    let inner_limit = 0;
    let topCounter = 0;
    let currentHexGalImg = "";
    let profileUrl = "";

    let imgcount = props.images.length;
    for (let i = 0, s = 0; i < imgcount; s++) {
      inner_limit = modValue - (s % 2);
      if (inner_limit === modValue) {
        itemCounter = 0;
      } else {
        itemCounter = 1;
      }

      for (let j = 0; j < inner_limit && i < imgcount; j++) {
        currentHexGalImg = props.images[i].images;
        profileUrl = props.images[i].id;

        if (inner_limit === modValue) {
          leftPos = itemCounter * (hexWidth + hexWidth / 2);
          itemCounter++;
        } else {
          leftPos = itemCounter * smallWidth;
          itemCounter += 2;
        }
        topPos = topCounter * verticalHeight;
        styleString = `width: ${hexWidth}px; left: ${leftPos}px; top: ${(topPos - 5)}px;`; // Updated styleString assignment
        hexagonGalSvg = `
          <div class="hex-svg-wrap" style="${styleString}">
            <a href="/user/contact/${profileUrl}/">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="107.028px" height="93.5px" viewBox="0 0 107.028 93.5" enable-background="new 0 0 107.028 93.5" xml:space="preserve">
                <pattern x="6.222" y="-1" width="100.126" height="100.5" patternUnits="userSpaceOnUse" id="imgs${i}" viewBox="1 -101.5 100.126 100.5" overflow="visible">
                  <g>
                    <polygon fill="none" points="1,-1 101.126,-1 101.126,-101.5 1,-101.5"/>
                    <image overflow="visible" width="280" height="250" xlink:href="${currentHexGalImg}" transform="matrix(0.3736 0 0 0.3736 1 -101.5)"></image>
                  </g>
                </pattern>
                <polygon fill="url(#imgs${i})" points="28.514,90.051 3.514,46.75 28.514,3.449 78.514,3.449 103.514,46.75 78.514,90.051" /> 
              </svg>
            </a>
          </div>
        `;
        $(".hex-gallery-wrapper").append(hexagonGalSvg);
        i++;
      }
      topCounter++;
    }
    $(".hex-gallery-wrapper").css(
      "height",
      hexWidth * (topCounter / 2) + hexWidth / 2
    );
  }
};






  const NextArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-down slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-down-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };


  const PrevArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-up slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-up-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };


  const settings = {
    infinite: true,
    dots: false,
    vertical: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    slidesPerRow: 1,
    swipeToSlide: true,
    verticalSwiping: true,
    nextArrow: (
      <div onClick>
        <div
          style={{
            display: isMobile ? "none" : "inline-block", // set visible only for webViews
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            // paddingTop: "5px",
          }}
        >
          <MdOutlineKeyboardArrowDown
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
    prevArrow: (
      <div className="row" onClick>
        <div
          style={{
            display: isMobile ? "none" : "inline-block", // set visible only for webViews
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            float: "right", // Float it to the right as specified
            // paddingTop:'4px'
          }}
        >
          <MdOutlineKeyboardArrowUp
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
  }


  useEffect(() => {
    if (props.images.length > 0) {
      createHoneycomb();
    }
  }, [props.images]);

  return (
    <div className="row mt-5">
      <div className="col-12">
        <div className="hexagon-gallery-section">
          <h2 className="block-title">MY Connections</h2>
          <Slider {...settings}>
            {props.images.map((image, index) => (
              <div className="hex-gallery-wrapper" data-item-row="8" key={index}>
                <div className="hex-gallery-item">
                  {/* Render individual hexagonal items here */}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default HexagonalGallery